// extracted by mini-css-extract-plugin
module.exports = {"product-review-container":"MainProductReview_product-review-container__mbx63","product-hero__review-link":"MainProductReview_product-hero__review-link__VPy4j"};